import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { createEntity } from "../../../entities";

export const FETCH_DATA_CREATE_ENTITY_REQUEST =
  "FETCH_DATA_CREATE_ENTITY_REQUEST";
export const FETCH_DATA_CREATE_ENTITY_SUCCESS =
  "FETCH_DATA_CREATE_ENTITY_SUCCESS";
export const FETCH_DATA_CREATE_ENTITY_FAILURE =
  "FETCH_DATA_CREATE_ENTITY_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDataCreateEntityRequest = () => {
  return {
    type: FETCH_DATA_CREATE_ENTITY_REQUEST,
  };
};

const fetchDataCreateEntitySuccess = (
  data: any
): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DATA_CREATE_ENTITY_SUCCESS,
    payload: data,
  };
};

const fetchDataCreateEntityFailure = (error: any) => {
  return {
    type: FETCH_DATA_CREATE_ENTITY_FAILURE,
    payload: error,
  };
};

export const create_entity = (data: any) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDataCreateEntityRequest());
    try {
      const response = await createEntity(data);
      dispatch(fetchDataCreateEntitySuccess(response.data));
    } catch (error: any) {
      dispatch(fetchDataCreateEntityFailure(error.message));
    }
  };
};
